export function assignTrOrderNumber(
  orderObjectId: string | undefined,
  tireRackNumber: string,
) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderObjectId}/tire-rack/${tireRackNumber}`,
  }
}
